import React from "react";
import {
  Stethoscope,
  ClipboardPlus,
  ClipboardCheck,
  PhoneCall,
} from "lucide-react";
import "./OrthopedicCare.css";

const OrthopedicCare = () => {
  return (
    
    <section className="orthopedic-care">
      {/* Column 1 */}
      <div className="care-card card-one">
        <div className="care-icon">
          <Stethoscope size={42} strokeWidth={1.7} />
        </div>

        <div className="care-content">
          <h2>Expert Orthopedic Care</h2>

          <p> 
            Provides advanced, evidence-based treatment for bone, joint, and
            spine conditions, including fractures, arthritis, and sports
            injuries. With expertise in joint replacement and trauma care, he
            focuses on pain relief, faster recovery, and better quality of
            life.
          </p>

          <div className="phone-box">
            <div className="phone-icon">
              <PhoneCall size={27} strokeWidth={1.8} />
            </div>

            <a href="tel:9547272538"> 9547272538</a>
          </div>
        </div>
      </div>

      {/* Column 2 */}
      <div className="care-card card-two">
        <div className="care-icon">
          <ClipboardPlus size={45} strokeWidth={1.7} />
        </div>

        <div className="care-content">
          <h2>Prioritize Your Health</h2>

          <p>
           Take the first step towards a healthier, more active life with expert orthopedic care from Dr. Rajkishore Sarkar (MBBS, MS Ortho). From accurate diagnosis to advanced treatment, we focus on relieving pain, restoring mobility, and helping you return to your everyday activities with confidence.
          </p>
<a href="doctor">
          <button className="care-btn">
            Make Appointment
          </button>
          </a>
        </div>
      </div>

      {/* Column 3 */}
      <div className="care-card card-three">
        <div className="care-icon">
          <ClipboardCheck size={45} strokeWidth={1.7} />
        </div>

        <div className="care-content">
          <h2>Plan Your Visit</h2>

          <p>
           Book your consultation with Dr. Rajkishore Sarkar (MBBS, MS Ortho) for trusted and specialized orthopedic care. Get accurate diagnosis, personalized treatment plans, and compassionate guidance focused on relieving pain, restoring mobility, and supporting a faster, healthier recovery.
          </p>

          <button className="care-btn">
            Discover Timetable
          </button>
        </div>
      </div>
    </section>
  );
};

export default OrthopedicCare;